<template>
    <div v-if="userStatus !== null">
        
        <template v-if="userStatus.status === 'online'">
            <div class="status hint hint--top online" data-hint="Online"></div>
        </template>

        <template v-else-if="userStatus.status === 'offline'">

            <template v-if="isIdle.status === 'idle'">
                <div
                    class="status hint hint--top idle"
                    :data-hint="isIdle.hint"
                >
                    <span class="min">{{ isIdle.time }}</span>
                </div>
            </template>

            <template v-else-if="isIdle.status === 'offline'">
                <div class="status hint hint--top offline" :data-hint="isIdle.hint"></div>
            </template>

        </template>

    </div>
</template>

<script>
import moment from 'moment'
const fb = require('@/firebaseConfig.js')

export default {
    name: 'MemberStatus',

    data(){
        return{
            userStatus: {}
        }
    },

    props: {
        memberId: String
    },
    
    mounted(){
        this.$rtdbBind('userStatus', fb.rdb.ref(`status/${this.memberId}`))
    },

    computed: {
        isIdle(){
            let today = moment()
            let lastOnline = moment(this.userStatus.timestamp)
            let min = today.diff(lastOnline, 'minutes')

            if(min < 60){
                if(min === 0){
                    return {
                        status: 'idle',
                        time: '1m',
                        hint: lastOnline.format('MMM D, YYYY - h:mm a')
                    }
                }else{
                    return {
                        status: 'idle',
                        time: min + 'm',
                        hint: lastOnline.format('MMM D, YYYY - h:mm a')
                    }
                }
            }

            return {
                status: 'offline',
                hint: lastOnline.format('MMM D, YYYY - h:mm a')
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/MemberStatus.vue